import React, { useEffect } from "react";
import { useState, useRef, useContext } from "react";
import { ThemeButtonBGParaphrase } from "../Config";
import { useNavigate } from "react-router";
import { MIN_AI_TEXT_LENGTH } from "../Config";
import { formatSecondsToMS } from "../Utils";
import { copyTextToClipboard, getRandomInt } from "../Utils";
import { useLocation } from "react-router-dom";
import { REQUEST_URL, ALERT_TIMEOUT, STATUS_CHECK_INTERVAL } from "../Config";
import { Popover } from "react-tiny-popover";
import { LoggedInContext } from "../../App";

function ParaphraseTexts() {
  //navigate
  const navigate = useNavigate(); //react router navigate
  //location
  const location = useLocation();
  //user data sent from page
  const userData = location.state; // Access the data

  //delay time
  //delay to run the code in runpod server i.e in queue time
  //execution time
  //time taken to execute the code
  //total time is = delayTime + executionTime
  var process_time = useRef({
    delayTime: 0.0,
    executionTime: 0.0,
  });

  //time to show time value
  //initialise with 2 minutes
  const [time, setTime] = useState(60 * 2);

  //
  //get ai detector values
  // eslint-disable-next-line no-unused-vars
  const { maxAITextLength } = useContext(LoggedInContext);

  //submit form button clicked state
  const [submitClicked, setSubmitClicked] = useState(false);
  //result loadedstate
  const [resultLoaded, setResultLoaded] = useState(false);

  //timer id
  const timerId = useRef();

  //paraphrase texts form values
  const [paraphraseTextsValues, setParaphraseTextsValues] = useState({
    enter_main_text: userData === null ? "" : userData.text,
    paraphrased_text_array: [], //sentence id with selected sentence
    paraphrased_output_array: [], //sentence id with multiple phrases as array
  });

  //alert state
  const [alert, setAlert] = useState({
    type: "success",
    message: "",
    visible: false,
  });

  //handle mouse click
  const handleMouseClick = (event) => {
    // //new array
    var arr = [...paraphraseTextsValues.paraphrased_text_array];

    //set is list showing
    arr.forEach((item, index) => {
      //set
      item.isListShowing =
        index.toString() === event.target.id
          ? item.isListShowing
            ? false
            : true
          : false;
    });

    //set value
    setParaphraseTextsValues({
      ...paraphraseTextsValues,
      paraphrased_text_array: arr,
    });

    console.log("Mouse click: ", event.target.id);
  };

  //use effect to handle the submit button click
  useEffect(() => {
    // If the submit button was clicked
    if (submitClicked === true) {
      //reset
      process_time.delayTime = 0.0;
      process_time.executionTime = 0.0;

      //call api to paraphrase texts
      paraphraseTextsAPICall();

      //time for time remaiming
      timerId.current = setInterval(
        () => setTime((time) => Math.max(0, time - 1)),
        1000
      );
    } else {
      //clear
      clearInterval(timerId.current);
      //reset
      setTime(60 * 2);
    }

    //if result loaded
    if (resultLoaded === true) {
      //update search history
      updateSearchHistory();
    }

    //cleanup
    return () => clearInterval(timerId); // Cleanup on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitClicked]);

  //check status from status from endpoint
  const checkRunpodJobStatus = async (job_id) => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the status from the API
    await fetch(REQUEST_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "STATUS_CHECK_PARAPHRASE_TEXTS",
        text_to_process: "",
        job_id: job_id, // can be used for tracking jobs
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //check success
        if (data.success === true) {
          //check status
          if (data.status === "COMPLETED") {
            //hide the spinner
            setSubmitClicked(false);

            //result json
            const result = JSON.parse(data.message);
            // Update the state with the new value
            setParaphraseTextsValues({
              ...paraphraseTextsValues,
              enter_main_text: result.text,
              paraphrased_text_array: getParaphrasedTextArray(
                result.paraphrased_output
              ),
              paraphrased_output_array: result.paraphrased_output,
            });

            //set time
            process_time.delayTime = data.delay_time;
            process_time.executionTime = data.execution_time;

            //set
            setResultLoaded(true);
          } else if (
            data.status === "FAILED" ||
            data.status === "CANCELLED" ||
            data.status === "TIMED_OUT"
          ) {
            //hide the spinner
            setSubmitClicked(false);

            //set alert state to show error
            setAlert({
              type: "danger",
              message: "Failed to detect text. Please try again.",
              visible: true,
            });
            //hide alert after 5 seconds
            setTimeout(() => {
              setAlert({ ...alert, visible: false });
            }, ALERT_TIMEOUT);
          } else if (
            data.status === "IN_QUEUE" ||
            data.status === "RUNNING" ||
            data.status === "IN_PROGRESS"
          ) {
            //check api after 10 seconds
            setTimeout(() => {
              //callback
              checkRunpodJobStatus(job_id);
            }, STATUS_CHECK_INTERVAL);
          }
        } else {
          //hide the spinner
          setSubmitClicked(false);
          //scroll to top
          window.scrollTo(0, 0);
          //set alert state to show error
          setAlert({
            type: "danger",
            message: data.message || "Failed to detect text. Please try again.",
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);
        }

        console.log("Response Data paraphraser:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        //hide the spinner
        setSubmitClicked(false);

        //set alert state to show error
        setAlert({
          type: "danger",
          message: "Failed to detect text. Please try again.",
          visible: true,
        });
        //hide alert after 5 seconds
        setTimeout(() => {
          setAlert({ ...alert, visible: false });
        }, ALERT_TIMEOUT);
      });
  };

  //paraphrase texts from endpoint
  const paraphraseTextsAPICall = async () => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the humanized text from the API
    await fetch(REQUEST_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "PARAPHRASE_TEXTS",
        text_to_process: paraphraseTextsValues.enter_main_text,
        mode: 0,
        job_id: null, // can be used for tracking jobs
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //set token in local storage
        localStorage.setItem("access_token", data.token);

        //check if the response is successful
        //and job is send to runpod server
        if (data.success === true) {
          //set job_id
          const job_id = data.job_id;
          //check response from runpod server
          //when ai detection text is completed
          if (
            data.status === "FAILED" ||
            data.status === "CANCELLED" ||
            data.status === "TIMED_OUT" ||
            job_id === null
          ) {
            //hide the spinner
            setSubmitClicked(false);

            //set alert state to show error
            setAlert({
              type: "danger",
              message: "Failed to process text. Please try again.",
              visible: true,
            });
            //hide alert after 5 seconds
            setTimeout(() => {
              setAlert({ ...alert, visible: false });
            }, ALERT_TIMEOUT);
          } else {
            //check status for job_id
            checkRunpodJobStatus(job_id);
          }
        } else {
          //hide the spinner
          setSubmitClicked(false);
          //scroll to top
          window.scrollTo(0, 0);
          //set alert state to show error
          setAlert({
            type: "danger",
            message: data.message || "Failed to detect text. Please try again.",
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);
        }

        console.log("Response Data paraphraser:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        //hide the spinner
        setSubmitClicked(false);
        //set alert state to show error
        setAlert({
          type: "danger",
          message:
            "Failed to detect text. Please try again. \n" + error.message,
          visible: true,
        });

        //hide
        setTimeout(() => {
          //hide alert after 5 seconds
          setAlert({ ...alert, visible: false });
        }, ALERT_TIMEOUT);
      });
  };

  //update search history
  async function updateSearchHistory() {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the humanized text from the API
    await fetch(REQUEST_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "INSERT_SEARCH_TO_HISTORY",
        text_searched: paraphraseTextsValues.enter_main_text,
        text_result: getSentenceFromParaphrasedArray(
          paraphraseTextsValues.paraphrased_text_array
        ),
        delay_time: process_time.delayTime,
        execution_time: process_time.executionTime,
        search_type: "PARAPHRASE_TEXTS",
      }),
    })
      .then((result) => result.json())
      .then((data) => {
        //reset
        setResultLoaded(false);

        console.log("Search history result: ", data);
      })
      .catch((error) => {
        //reset
        setResultLoaded(false);
      });

    console.log("Update Search History");
  }

  //submit handler for the form
  const onSubmitParaphraseTextsForm = (event) => {
    // Get the textarea value
    event.preventDefault();

    //check if empty string
    if (paraphraseTextsValues.enter_main_text.length <= MIN_AI_TEXT_LENGTH) {
      //show error
      //set alert state to show error
      setAlert({
        type: "danger",
        message: "Too short text. Please enter atleast 40 characters.",
        visible: true,
      });
      //hide alert after 5 seconds
      setTimeout(() => {
        setAlert({ ...alert, visible: false });
      }, ALERT_TIMEOUT);
      //return
      return;
    }

    //check text count
    if (paraphraseTextsValues.enter_main_text.length > maxAITextLength) {
      //show warning
      //set alert state to show error
      setAlert({
        type: "warning",
        message:
          "Max character limit exceeded. Input texts will be trimmed before processing.",
        visible: true,
      });
      //hide alert after 5 seconds
      setTimeout(() => {
        setAlert({ ...alert, visible: false });
      }, ALERT_TIMEOUT);
      // Update the state with the new value
      setParaphraseTextsValues({
        ...paraphraseTextsValues,
        enter_main_text: paraphraseTextsValues.enter_main_text.substring(
          0,
          maxAITextLength
        ),
      });
    }

    //set the submit clicked state to true
    //can not access the form values directly here
    //as the state is not updated immediately
    //use effect will be called after the state is updated
    setSubmitClicked(true);
  };

  //onvalue change handler for the textarea
  const onChangeParaphraseTextsForm = (event) => {
    // Update the state with the new value
    setParaphraseTextsValues({
      ...paraphraseTextsValues,
      [event.target.id]: event.target.value,
    });
  };

  return (
    <div className="p-3">
      <div className="container">
        <div style={{ marginTop: "6rem" }}>
          {/* Alert for failure */}
          <div
            className={`alert alert-${alert.type} ${
              alert.visible ? "" : "d-none"
            } fade show`}
            role="alert"
            style={{ marginTop: "5rem" }}
          >
            {alert.message}
          </div>

          {/* Heading */}
          <h1 className="display-6 text-center mt-2">Paraphrasing Tool</h1>
          <p className="text-center lead mt-4">
            Transform your writings instantly with our powerful paraphrasing
            tool. Whether you need to simplify, reword, or improve your text,
            our AI ensures clarity, originality, and a natural human-like
            tone—perfect for students, professionals, and content creators.
            Select from multiple phrases and replace your existing sentence.
          </p>

          {/* input text to paraphrase */}
          <form onSubmit={onSubmitParaphraseTextsForm}>
            <div className="container mt-5">
              <div className="row">
                <div className="col-lg-6 col-sm-12">
                  <div className="position-relative">
                    <textarea
                      className="form-control m-2 shadow"
                      id="enter_main_text"
                      style={{ resize: "none", height: "500px" }}
                      placeholder="Insert (English) text here..."
                      onChange={onChangeParaphraseTextsForm}
                      value={paraphraseTextsValues.enter_main_text}
                    ></textarea>
                    <p
                      className="text-center position-absolute ms-4 mb-2 bg-light p-2 rounded"
                      style={{ bottom: "0px" }}
                    >
                      <span
                        className={`${
                          paraphraseTextsValues.enter_main_text.length <=
                          MIN_AI_TEXT_LENGTH
                            ? "text-danger"
                            : ""
                        }`}
                      >
                        {paraphraseTextsValues.enter_main_text.length}
                      </span>{" "}
                      / {maxAITextLength} Characters
                    </p>

                    {/* CLEAR TEXT & PASTE TEXT buttons */}
                    <div
                      className="position-absolute me-2 mb-3 d-flex bg-light"
                      style={{ right: "0px", bottom: "0px" }}
                    >
                      {/*  paste from clipboard */}
                      <button
                        className="btn btn-outline-success btn-sm me-2"
                        type="button"
                        onClick={(e) => {
                          //text from clipboard
                          navigator.clipboard
                            .readText()
                            .then((text) => {
                              //set text
                              setParaphraseTextsValues({
                                ...paraphraseTextsValues,
                                enter_main_text: text,
                              });
                            })
                            .catch((err) => {
                              console.error(
                                "Failed to read clipboard contents: ",
                                err
                              );
                            });
                          // Remove focus after click
                          e.currentTarget.blur();
                        }}
                      >
                        <i className="bi bi-clipboard me-lg-2 me-sm-0"></i>
                        <span className="d-none d-sm-inline">Paste Texts</span>
                      </button>

                      {/* clear text area */}
                      <button
                        className="btn btn-outline-danger btn-sm"
                        type="button"
                        onClick={(e) => {
                          //clear
                          setParaphraseTextsValues({
                            enter_main_text: "",
                            paraphrased_text_array: [],
                          });
                          // Remove focus after click
                          e.currentTarget.blur();
                        }}
                      >
                        <i className="bi bi-trash3 me-lg-2 me-sm-0"></i>
                        <span className="d-none d-sm-inline">Clear Text</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-sm-12">
                  <div className="position-relative">
                    {/* Waiting time */}
                    <div
                      className={`position-absolute ${
                        submitClicked ? "" : "d-none"
                      }`}
                      style={{
                        left: "0px",
                        right: "0px",
                        margin: "auto",
                        top: "0px",
                        bottom: "0px",
                        width: "200px",
                        height: "100px",
                      }}
                    >
                      {/*Gray box */}
                      <div className="bg-secondary rounded-3 p-1">
                        <label
                          className="fs-5 text-light text-center"
                          style={{ width: "100%" }}
                        >
                          Waiting time:
                        </label>
                        <label
                          className="fs-3 text-light text-center"
                          style={{ width: "100%" }}
                        >
                          {formatSecondsToMS(time)}
                        </label>
                      </div>
                      {/* Text upgrade */}
                      <div className="bg-white bg-opacity-10">
                        <label className="text-muted text-center mt-2">
                          <span>
                            <button
                              className="btn btn-light"
                              type="button"
                              onClick={(e) => {
                                //blur
                                e.currentTarget.blur();
                                //go to pricing page
                                navigate("/pricing"); //Navigate to pricing page
                              }}
                            >
                              Upgrade
                            </button>
                          </span>{" "}
                          for quicker response time
                        </label>
                      </div>
                    </div>

                    <div
                      className="m-2 p-2 shadow border border-secondary rounded-1"
                      id="paraphrased_text"
                      style={{ height: "500px", overflow: "auto" }}
                    >
                      {/* Placeholder text */}
                      <label
                        className={`text-muted ${
                          paraphraseTextsValues.paraphrased_text_array
                            .length === 0
                            ? ""
                            : "d-none"
                        }`}
                      >
                        Paraphrased texts will appear here... select from
                        multiple phrases for each parts by clicking on it.
                      </label>

                      {/* html body for paraphrased texts */}
                      <div
                        className={`${
                          paraphraseTextsValues.paraphrased_text_array
                            .length === 0
                            ? "d-none"
                            : ""
                        }`}
                        id="paraphrased_html"
                        style={{ width: "100%", height: "100%" }}
                      >
                        {paraphraseTextsValues.paraphrased_text_array.map(
                          (value, key) => (
                            <Popover
                              key={`popover_${key}`}
                              id={`paraphrased_text_popover_${key}`}
                              isOpen={value.isListShowing}
                              positions={["top", "bottom", "left", "right"]} // preferred positions by priority
                              content={renderPhrasesListFotIndex(
                                key,
                                paraphraseTextsValues,
                                setParaphraseTextsValues
                              )}
                            >
                              <button
                                type="button"
                                key={`popover_label_${key}`}
                                id={key}
                                className="btn bg-light p-2 m-1 text-start"
                                onClick={handleMouseClick}
                              >
                                {value.sentence}
                              </button>
                            </Popover>
                          )
                        )}
                      </div>

                      {/* Copy text */}
                      <div
                        className="position-absolute d-flex me-4 mb-3 bg-light"
                        style={{ right: "0px", bottom: "0px" }}
                      >
                        {/*  copy to clipboard */}
                        <button
                          className="btn btn-outline-dark btn-sm"
                          type="button"
                          onClick={(e) => {
                            //blur
                            e.target.blur();
                            //copy
                            copyTextToClipboard(
                              getSentenceFromParaphrasedArray(
                                paraphraseTextsValues.paraphrased_text_array
                              )
                            );
                          }}
                        >
                          <i className="bi bi-clipboard2-check me-2"></i>Copy
                          Texts
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* button to paraphrase text */}
              <div className="text-center mt-5 justify-content-center d-flex">
                <div
                  className={`spinner-border text-dark me-3 align-self-center ${
                    submitClicked ? "visible" : "invisible"
                  }`}
                  role="status"
                >
                  <span className="sr-only"></span>
                </div>
                <button
                  className="btn btn-success px-4 py-3 fs-5"
                  disabled={submitClicked}
                  type="submit"
                  style={{
                    backgroundColor: submitClicked
                      ? "#6c757d"
                      : ThemeButtonBGParaphrase,
                  }}
                  onClick={(e) => {
                    //blur
                    e.currentTarget.blur();
                    //reset output
                    setParaphraseTextsValues({
                      ...paraphraseTextsValues,
                      paraphrased_text_array: [],
                      paraphrased_output: [],
                    });
                  }}
                >
                  Paraphrase Text
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

//render phrase list
function renderPhrasesListFotIndex(
  index,
  paraphraseTextsValues,
  setParaphraseTextsValues
) {
  return (
    <div className="border rounded p-2 bg-light shadow">
      <label
        className="fs-5 border-bottom text-center"
        style={{ width: "100%" }}
      >
        <b>Phrases</b>
      </label>
      <ol>
        {Object.keys(paraphraseTextsValues.paraphrased_output_array).includes(
          index.toString()
        ) ? (
          paraphraseTextsValues.paraphrased_output_array[index.toString()].map(
            (value, ind) => (
              <li className="border-bottom  py-2" key={ind}>
                <button
                  id={`btn_phrases_${ind}`}
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={(e) => {
                    //blur
                    e.target.blur();
                    //paraphrased text array
                    const arr = [
                      ...paraphraseTextsValues.paraphrased_text_array,
                    ];
                    //change sentence
                    //check
                    if (Object.keys(arr).includes(index.toString())) {
                      //change value
                      arr[index.toString()] = {
                        sentence: value,
                        isListShowing: false,
                      };
                    }

                    //set selected sentence to value state
                    setParaphraseTextsValues({
                      ...paraphraseTextsValues,
                      paraphrased_text_array: arr,
                    });
                  }}
                >
                  {value}
                </button>
              </li>
            )
          )
        ) : (
          <></>
        )}
      </ol>
    </div>
  );
}

//get paraphrased text array
//select random sentence form paraphrased_output
//insert them in a dictionary
//key = paraphrased_output key and value = random sentence
function getParaphrasedTextArray(paraphrased_output) {
  //sentence
  var paraphrased_text_array = [];

  //loop
  for (const [key, value] of Object.entries(paraphrased_output)) {
    //check
    if (value.length > 0) {
      //append
      paraphrased_text_array[key] = {
        sentence: value[getRandomInt(value.length - 1)],
        isListShowing: false,
      };
    }
  }

  //return
  return paraphrased_text_array;
}

//get text from paraphrased array
function getSentenceFromParaphrasedArray(paraphrased_text_array) {
  //sentence
  var sentence = "";

  //iterate
  Object.values(paraphrased_text_array).forEach((value) => {
    //append
    sentence += value.sentence;
  });

  //return
  return sentence;
}

export default ParaphraseTexts;
